import { render, staticRenderFns } from "./UsersetupAdd.vue?vue&type=template&id=6551d1d8&"
import script from "./UsersetupAdd.vue?vue&type=script&lang=js&"
export * from "./UsersetupAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports